(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.languageSelect = {
    attach: function (context, settings) {
      const $languageSelect = $('.js-language-select', context);
      $('.js-language-switcher', context).click(function () {
        if ($(this).hasClass('is-active')) {
          $languageSelect.removeClass('is-active');
          $(this).removeClass('is-active');
        } else {
          $(this).addClass('is-active');
          $languageSelect.addClass('is-active');
        }
      });

      const $languageFormSelect = $('.js-selected-language', context);

      $('.js-set-locality', context).click(function (e) {
        e.preventDefault();
        const selectedLanguage = $languageFormSelect.find(':selected').val();
        // Redirect to new language
        window.location = window.location.origin + selectedLanguage;
      });
    }
  };
})(window.Drupal, window.jQuery);
